import { CoachInfoSubcomponentProps } from "../CoachInfo";
import { DETAILS_SECTIONS, DetailsSection } from "../DetailsSections";

export default function CoachInfoDetails(
    props: CoachInfoSubcomponentProps & { inSeeMore: boolean },
) {
    const sectionsToShow = Object.entries(DETAILS_SECTIONS)
        .filter(
            ([section]) =>
                props.config.sectionsToShowOutsideOfSeeMore.includes(
                    section as DetailsSection,
                ) !== props.inSeeMore,
        )
        .map(([section, Component]) => <Component key={section} {...props} />);
    return (
        <div className="flex flex-col gap-6 mt-4 self-stretch text-brand-black">
            {sectionsToShow}
        </div>
    );
}
